module.exports = __webpack_public_path__ + "img/03.734b99f4.png";